import { addDays, addYears, startOfDay } from 'date-fns';
import { today } from 'AppReact';

const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ startDate: holder.startDate, endDate: holder.endDate })
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener('mousedown', holder.closeDateRangeSelector);
    }
  }
};


export default {
  'DateRangeSelector.Selector.Custom': ({ isOpen, containerRef, startDate, endDate }, outlet, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.outlet = outlet;
    holder.startDate = startDate;
    holder.endDate = endDate;
    internalStateSetter({ isOpen: !isOpen, selectedCalendar: 'custom' });
    if (isOpen) {
      document.removeEventListener('mousedown', holder.closeDateRangeSelector);
    } else {
      document.addEventListener('mousedown', holder.closeDateRangeSelector);
    }
  },
  'DateRangeSelector.Selector.All': ({ }, outlet, internalStateSetter) => {
    const dates = { startDate: addYears(today(), -10), endDate: today() };
    internalStateSetter({ ...dates, selectedCalendar: 'all' });
    outlet(dates);
  },
  'DateRangeSelector.Selector.Today': ({ }, outlet, internalStateSetter) => {
    const dates = { startDate: today(), endDate: today() };
    internalStateSetter({ ...dates, selectedCalendar: 'today' });
    outlet(dates);
  },
  'DateRangeSelector.Selector.Week': ({ }, outlet, internalStateSetter) => {
    const dates = { startDate: addDays(today(), -7), endDate: today() };
    internalStateSetter({ ...dates, selectedCalendar: 'week' });
    outlet(dates);
  },
  'DateRangeSelector.Body.StartCalendar': ({ selectedDate, disabledAfter }, _, internalStateSetter) => {
    if (selectedDate > disabledAfter) {
      internalStateSetter({ startDate: selectedDate, endDate: selectedDate });
      holder.startDate = selectedDate;
      holder.endDate = selectedDate;
    } else {
      internalStateSetter({ startDate: selectedDate });
      holder.startDate = selectedDate;
    }
  },

  'DateRangeSelector.Body.EndCalendar': ({ selectedDate, disabledBefore }, _, internalStateSetter) => {
    if (selectedDate < disabledBefore) {
      internalStateSetter({ startDate: selectedDate, endDate: selectedDate });
      holder.startDate = selectedDate;
      holder.endDate = selectedDate;
    } else {
      internalStateSetter({ endDate: selectedDate });
      holder.endDate = selectedDate;
    }
  },
};
